module.exports = __webpack_public_path__ + "img/a.94b611ee.jpg";